<template>
  <div v-show="dialogVisible" class="search-video-cont-dialog">
    <div class="search-wrap">
      <!-- @keyup.enter.native="onSearch" -->
      <el-input
        ref="searchInput"
        class="search-input"
        placeholder="搜索关键字"
        size="medium"
        v-model.trim="keyword"
        maxlength="100"
        @input="handleInput"
      >
        <!--   @click.stop="onSearch" -->
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <button @click="closeDialog" class="close-btn">
        <img src="../../../assets/images/icon/close.png" alt="" />
      </button>
    </div>
    <div class="result-wrap" v-if="searchResult?.length">
      <div
        class="result-item"
        @click="playCurNode(item.start_second)"
        v-for="(item, index) in searchResult"
        :key="index"
      >
        <span class="time">{{ formatTimeBySecond(item.start_second) }}</span>
        <p
          class="cont ellipsis"
          v-html="keyword ? handleKeyWordHilight(item.showText) : item.content"
        ></p>
      </div>
    </div>
    <div v-else class="empty-wrap">暂无搜索内容</div>
    <div v-if="false" class="empty-wrap">搜索到的片段会出现在这里</div>
  </div>
</template>

<script>
import { getJSON } from "@saas/server-api/src/request";
import { mapState } from "vuex";
import { formatTimeBySecond } from "@saas/components/src";
export default {
  data() {
    return {
      keyword: "", // 搜索关键字
      searchResult: [], // 搜索结果
      formatTimeBySecond,
      dialogVisible: false,
      subTitleList: [], // 字幕列表
      initSubNum: 20, // 初始显示的字幕数量
    };
  },
  mounted() {
    document.removeEventListener("click", this.handleClickOutClose);
    document.addEventListener("click", this.handleClickOutClose);
  },
  methods: {
    playCurNode(time) {
      this.$emit("playCurNode", time);
      this.closeDialog();
    },
    handleClickOutClose(event) {
      if (!this.dialogVisible) {
        return;
      }
      const openPopupButton = document.querySelector(
        ".ai-right-operation-component .top-operate .find-cont"
      );
      const popup = document.querySelector(".search-video-cont-dialog");
      if (
        !popup.contains(event.target) &&
        !openPopupButton.contains(event.target)
      ) {
        this.closeDialog();
      }
    },
    closeDialog() {
      this.dialogVisible = false;
      this.keyword = "";
      this.searchResult = this.subTitleList.slice(0, this.initSubNum);
    },
    openDialog() {
      this.searchResult = this.subTitleList.slice(0, this.initSubNum);

      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    onSearch() {
      if (this.keyword) {
        this.getSearchResult(this.keyword);
      } else {
        this.searchResult = this.subTitleList.slice(0, this.initSubNum);
      }
    },
    handleInput(value) {
      if (value) {
        this.getSearchResult(this.keyword);
      } else {
        this.searchResult = this.subTitleList.slice(0, this.initSubNum);
      }
    },
    getSearchResult(value) {
      this.searchResult = this.subTitleList.filter((item) => {
        const content = item?.content || "";
        const index = content.indexOf(value);

        if (index !== -1) {
          // 找到匹配项，添加showText字段
          item.showText = content.substring(index);
          return true;
        }

        return false;
      });
    },
  },
  computed: {
    ...mapState("replay", ["subTitle"]),
    handleKeyWordHilight() {
      return (str) => {
        if (!str) return "";
        const regex = new RegExp(this.keyword, "g");
        return str.replace(
          regex,
          `<span class="highlight">${this.keyword}</span>`
        );
      };
    },
  },
  watch: {
    subTitle: {
      handler(val) {
        if (val) {
          getJSON(`${process.env.VUE_APP_CDN_URL}${val}`).then((res) => {
            this.subTitleList = res || [];
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.search-video-cont-dialog {
  // width: 300px;
  min-height: 178px;
  max-height: 250px;
  border-radius: 6px;
  background: rgba($color: #fff, $alpha: 0.7);
  backdrop-filter: blur(31px);
  display: flex;
  flex-direction: column;
  align-items: center;
  .search-wrap {
    width: 100%;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .close-btn {
      width: 20px;
      height: 20px;
    }
  }
  .empty-wrap {
    flex: 1;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #86909c;
  }
  .result-wrap {
    flex: 1;
    width: 100%;
    overflow-y: auto;
    padding: 6px 3px;
    &:hover::-webkit-scrollbar-thumb {
      //   background: #c9cdd4;
    }
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      //   background: transparent;
      background: #d4f1e1;
      border-radius: 2px;
    }
    .result-item {
      display: flex;
      padding: 4px 3px;
      cursor: pointer;
      &:hover {
        background: #ffffff;
        border-radius: 4px;
      }
    }
    .time {
      min-width: 52px;
      height: 24px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #f2f3f5;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 4px;
      font-size: 11px;
      color: #4e5969;
    }
    ::v-deep .cont {
      flex: 1;
      font-size: 14px;
      color: #1d2129;
      line-height: 22px;
      .highlight {
        color: #00c89d;
      }
    }
  }
}
.search-input {
  width: 263px;
  height: 30px;

  .el-icon-search {
    cursor: pointer;
  }
}
::v-deep .search-input input {
  background: #ffffff;
  color: #1d2129;
}
::v-deep .el-input__inner {
  border-radius: 6px;
  border: none;
}
::v-deep .el-input__inner::placeholder {
  font-size: 14px;
  color: #c9cdd4;
}
</style>
